import { render, staticRenderFns } from "./subsPause.vue?vue&type=template&id=1ce18916&scoped=true"
import script from "./subsPause.vue?vue&type=script&lang=js"
export * from "./subsPause.vue?vue&type=script&lang=js"
import style0 from "./subsPause.vue?vue&type=style&index=0&id=1ce18916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce18916",
  null
  
)

export default component.exports